import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { PopupCookie } from '~js/components/popup-cookie';

export class Newsletter {
  constructor(newsletter) {
    this.newsletter = newsletter;
    this.sessionStorage = window.sessionStorage;
    this.popup = this.newsletter.closest(s.selectors$p.popup);
    this.stopSubmit = true;
    this.isChallengePage = false;
    this.formID = null;
    this.formIdSuccess = null;

    this.checkForChallengePage();

    this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e);

    if (!this.isChallengePage) {
      this.init();
    }
  }

  init() {
    this.newsletter.addEventListener('submit', this.newsletterSubmit);

    this.showMessage();
  }

  newsletterSubmitEvent(e) {
    if (this.stopSubmit) {
      e.preventDefault();

      this.removeStorage();
      this.writeStorage();
      this.stopSubmit = false;
      this.newsletter.submit();
    }
  }

  checkForChallengePage() {
    this.isChallengePage = window.location.pathname === theme.routes.root + 'challenge';
  }

  writeStorage() {
    if (this.sessionStorage !== undefined) {
      this.sessionStorage.setItem(a.attributes$g.storageNewsletterFormId, this.newsletter.id);
    }
  }

  readStorage() {
    this.formID = this.sessionStorage.getItem(a.attributes$g.storageNewsletterFormId);
  }

  removeStorage() {
    this.sessionStorage.removeItem(a.attributes$g.storageNewsletterFormId);
  }

  showMessage() {
    this.readStorage();

    if (this.newsletter.id === this.formID) {
      const newsletter = document.getElementById(this.formID);
      const submissionSuccess = window.location.search.indexOf('?customer_posted=true') !== -1;
      const submissionFailure = window.location.search.indexOf('accepts_marketing') !== -1;

      if (submissionSuccess) {
        newsletter.classList.remove(c.classes$h.error);
        newsletter.classList.add(c.classes$h.success);

        if (this.popup) {
          this.cookie = new PopupCookie(this.popup.dataset.cookieName, 'user_has_closed');
          this.cookie.write();
        }
      } else if (submissionFailure) {
        newsletter.classList.remove(c.classes$h.success);
        newsletter.classList.add(c.classes$h.error);
      }

      if (submissionSuccess || submissionFailure) {
        this.scrollToForm(newsletter);
      }
    }
  }

  /**
   * Scroll to the last submitted newsletter form
   */
  scrollToForm(newsletter) {
    const rect = newsletter.getBoundingClientRect();
    const isVisible =
      visibilityHelper.isElementPartiallyVisible(newsletter) || visibilityHelper.isElementTotallyVisible(newsletter);

    if (!isVisible) {
      setTimeout(() => {
        window.scrollTo({
          top: rect.top,
          left: 0,
          behavior: 'smooth',
        });
      }, 400);
    }
  }

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
    this.newsletter.removeEventListener('submit', this.newsletterSubmit);
  }
}